export default __webpack_public_path__ + "static/media/Made_in_india_PC.fc0941b6.jpg";